
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useAuth } from '../../../../../auth';
import { useLocation } from 'react-router-dom';
import { generateAddress } from '../../../../../../../_metronic/helpers';


interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const TextileSaleOrderPopUp: FC<UserTableModalProps> = ({ user, onClose, show }) => {


    const location = useLocation();
    const currentPath = location.pathname;
    const { currentUser } = useAuth()
    const userType = (currentUser as any).userType;
    console.log("userrr", user)

    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}>X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h3 className="mb-3" style={{ fontWeight: 600, fontSize: "17.55px" }}>View Order Details</h3>
                    </div>



                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        marginBottom: '20px',
                        tableLayout: 'fixed'
                    }}>
                        <thead>
                            <tr>
                                <th style={{
                                    width: '50%',
                                    backgroundColor: "#BFD7ED",
                                    color: "black",
                                    fontWeight: "bold",
                                    padding: "12px",
                                    textAlign: "center",
                                    border: "1px solid #ddd"
                                }}>
                                    Order Id
                                </th>
                                <th style={{
                                    width: '50%',
                                    backgroundColor: "#BFD7ED",
                                    color: "black",
                                    fontWeight: "bold",
                                    padding: "12px",
                                    textAlign: "center",
                                    border: "1px solid #ddd"
                                }}>
                                    Buyer
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ padding: '10px', textAlign: 'center', border: '1px solid #ddd' }}>
                                    {user?.saleOrderId}
                                </td>
                                <td style={{ padding: '10px', textAlign: 'center', border: '1px solid #ddd' }}>
                                    {user?.sellerName}
                                </td>
                            </tr>
                        </tbody>
                    </table>



                    <>
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>
                            <thead style={{ backgroundColor: '#BFD7ED' }}>
                                <tr>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Supply Address</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{generateAddress(user?.sellerAddress?.[0]) || 'N/A'}</td>

                                </tr>

                            </tbody>
                        </table>
                        <div className="table-responsive">
                            <table style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                marginBottom: "20px",
                                border: "1px solid #ddd"
                            }}>
                                <thead>
                                    <tr>
                                        <th
                                            colSpan={2}
                                            style={{
                                                backgroundColor: "#BFD7ED",
                                                color: "black",
                                                fontWeight: "bold",
                                                padding: "12px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                            Order Details
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{
                                            width: "33%",
                                            padding: "10px",
                                            textAlign: "left",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Category
                                        </td>
                                        <td style={{
                                            padding: "10px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            {user?.orderDetail?.[0]?.categoryName || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            fontWeight: "bold",
                                            padding: "10px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            Item
                                        </td>
                                        <td style={{
                                            padding: "10px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            {user?.orderDetail?.[0]?.items?.[0]?.itemName || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            fontWeight: "bold",
                                            padding: "10px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            Grade
                                        </td>
                                        <td style={{
                                            padding: "10px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            {user?.orderDetail?.[0]?.items?.[0]?.gradeName || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            fontWeight: "bold",
                                            padding: "10px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            Quantity (Kgs)
                                        </td>
                                        <td style={{
                                            padding: "10px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            {user?.orderDetail?.[0]?.items?.[0]?.quantity || ''}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            fontWeight: "bold",
                                            padding: "10px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            Approved Quantity (Kgs)
                                        </td>
                                        <td style={{
                                            padding: "10px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            {user?.confirmOrderQuantity || ''}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            fontWeight: "bold",
                                            padding: "10px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            Price (INR/Kgs)
                                        </td>
                                        <td style={{
                                            padding: "10px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            {user?.orderDetail?.[0]?.items?.[0]?.price || ''}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>


                    </>
                    <>
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>
                            <thead style={{ backgroundColor: '#BFD7ED' }}>
                                <tr>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Payment Terms</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Supplied Quantity (Kgs)</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Balance Quantity (Kgs)</th>

                                </tr>
                            </thead>
                            <tbody>

                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <div style={{ fontWeight: '' }}>{user?.paymentTerms?.[0] || 'N/A'}</div>
                                        {/* <div style={{ marginTop: '4px', color: '#666' }}>{user.buyerInfo?.address || 'N/A'}</div> */}
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <div style={{ fontWeight: '' }}>{user?.consumedQuantity || 'N/A'}</div>
                                        {/* <div style={{ marginTop: '4px', color: '#666' }}>{user.buyerInfo?.address || 'N/A'}</div> */}
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <div style={{ fontWeight: '' }}>{user?.confirmOrderQuantity - user?.consumedQuantity}</div>
                                        {/* <div style={{ marginTop: '4px', color: '#666' }}>{user.buyerInfo?.address || 'N/A'}</div> */}
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>
                            <thead style={{ backgroundColor: '#BFD7ED' }}>
                                <tr>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Purchase Order</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        {user?.images?.[0]?.docUrl ? (
                                            <>

                                                <img
                                                    src={user.images[0].docUrl}
                                                    alt="Document"
                                                    style={{
                                                        maxWidth: '200px',     // adjust as needed
                                                        maxHeight: '200px',
                                                        objectFit: 'contain',  // or 'cover'
                                                        borderRadius: '4px',
                                                    }}
                                                    onError={(e) => {
                                                        e.currentTarget.style.display = 'none'; // hide broken image
                                                        // optionally show fallback text
                                                    }}
                                                />
                                                <br />
                                                <p>{user?.images?.[0]?.docNumber}</p>
                                            </>
                                        ) : (
                                            'N/A'
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </>
                    <div className="table-responsive">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed'
                        }}>
                            <thead>
                                <tr className="fw-bold bg-light">
                                    <th className="min-w-100px" style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Approved By</th>
                                    <th className="min-w-100px" style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Date</th>
                                    <th className="min-w-100px" style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.workflowLogs?.[0]?.role || 'N/A'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.workflowLogs?.[0]?.time
                                                ? new Date(user.workflowLogs[0].time).toLocaleString('en-GB', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: true
                                                })
                                                : 'N/A'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.workflowLogs?.[0]?.action || 'N/A'}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>






            </div>
        </Modal>
    );
};